module.exports = __webpack_public_path__ + "static/img/MONOPOLY.cb033711.png";